
<template>
    <v-container class="results" grid-list-md text-xs-center>

        <v-layout row wrap justify-center>
            <v-flex xs6 sm4 md2>
              <m-box label="clients" :value="data.clients" icon="group" color="primary"></m-box>
            </v-flex>
            <v-flex xs6 sm4 md2>
              <m-box label="bookings" :value="data.bookings" icon="drive_eta" color="primary"></m-box>
            </v-flex>
            <v-flex xs6 sm4 md2>
              <m-box label="sales" :value="data.total_price_all | currency(true, true)" icon="euro_symbol" color="primary"></m-box>
            </v-flex>
            <v-flex  xs6 sm4 md2>
              <m-box label="cash" :value="data.total_cash | currency(true, true)" icon="euro_symbol" color="primary"></m-box>
            </v-flex>
            <v-flex xs6 sm4 md2>
              <m-box label="factuur" :value="data.total_factuur | currency(true, true)" icon="euro_symbol" color="primary"></m-box>
            </v-flex>
            <v-flex xs6 sm4 md2>
              <m-box label="invoiced" :value="data.total_invoiced | currency(true, true)" icon="euro_symbol" color="white"></m-box>
            </v-flex>

            <v-flex xs12 v-if="unpayed.late">
              <v-card class="py-1">
             <v-layout>


              <v-flex xs3 >

                <pie-chart height="380px" title="Un payed invoices" :data="[['Late', unpayed.late.amount], ['Unpayed', unpayed.total.amount - unpayed.late.amount]]" :colors="[$vuetify.theme.themes.light.primary, '#ccc']" label="€"></pie-chart>

              </v-flex>
              <v-flex xs3>

                <pie-chart height="380px"  :data="[['Invoiced', data.total_invoiced], ['Factuur', data.total_factuur]]" :colors="['#ccc', $vuetify.theme.themes.light.primary]" label="€"></pie-chart>

              </v-flex>
              <v-flex xs6>

                <bar-chart height="380px" :data="unpayed.list" :colors="[$vuetify.theme.themes.light.primary, '#ccc']" xtitle="€" label="€" ></bar-chart>

              </v-flex>
          </v-layout>
          </v-card>
          </v-flex>
          </v-layout>



           <v-layout row wrap>
            <v-flex  xs12>
            <v-card class="pb-1">
              <column-chart :data="bymonth" :colors="[$vuetify.theme.themes.light.primary, '#ccc']" ></column-chart>
              <column-chart :data="bymonthStack" :colors="[$vuetify.theme.themes.light.primary, '#ccc']" :stacked="true"></column-chart>
              <column-chart :data="bymonthBookings" :library="{'trendlines': trendlines, backgroundColor: '#eee'}" :colors="[$vuetify.theme.themes.light.primary, '#ccc']" :curve="false"></column-chart>

              <line-chart :library="{'trendlines': trendlines}" :data="bydayTotal" :colors="['#ccc', $vuetify.theme.themes.light.primary]" label="€ by day" legend="top"></line-chart>

              <line-chart :library="{'trendlines': trendlines}" :data="byday6m" :colors="['#ccc', '#b00']" label="bookings by day" legend="top"></line-chart>

              <GChart type="ComboChart" :data="chartData" :options="chartOptions" />

            </v-card>
            </v-flex>
            <v-flex xs12 sm5 md4>
              <!-- <m-asbl :results="data" color="white"></m-asbl> -->
                          <v-card>

            </v-card>

            </v-flex>
          </v-layout>

           <v-layout row wrap>
            <v-flex  xs12>

            </v-flex>
            <v-flex  xs12>
              <v-card class="pb-1">
              <column-chart :data="byday" :colors="[$vuetify.theme.themes.light.primary, '#ccc']" label="€" legend="top" :stacked="true"></column-chart>
              <column-chart :library="{'trendlines': trendlines}" :data="bookingsByHour" :colors="['#ccc', '#b00']" label="bookings by hour" legend="top"></column-chart>
              </v-card>
            </v-flex>

          </v-layout>



    </v-container>
</template>
<script>
import MBox from '@/components/balance/box.vue'
import sma from '@/utils/sma'
//import MResultsASBL from '@/components/balance/asbl.vue'
export default {
  components: {
    //'m-asbl': MResultsASBL,
    'm-box': MBox
  },
  name: 'results',
  data () {
    return {
      data: {},
      bymonth: [],
      bymonthStack: [],
      bymonthBookings: [],
      byday: [],
      byday6m: [],
      bookingsByHour: [],
      bydayTotal: null,
      unpayed: {},
      trendlines: {
        // 0 = first series
        0: {
          color: this.$vuetify.theme.themes.light.primary,
          type: 'polynomial',
          pointSize: 2
        }
      },
      chartData: [
        ['Year', 'Sales', 'Expenses', 'Profit'],
        ['2014', 1000, 400, 200],
        ['2015', 1170, 460, 250],
        ['2016', 660, 1120, 300],
        ['2017', 1030, 540, 350]
      ],
      geoData: [
          ['Country', 'Popularity'],
          ['Germany', 200],
          ['United States', 300],
          ['Brazil', 400],
          ['Canada', 500],
          ['France', 600],
          ['RU', 700]
      ],
      chartOptions: {
        chart: {
          title: "Company Performance",
          subtitle: "Sales, Expenses, and Profit: 2014-2017"
        },
        seriesType: 'bars',
        series: {1: {type: 'line'}},
        height: 300,
        curveType: 'function',
        trendlines: {
          // 0 = first series
          1: {
            color: this.$vuetify.theme.themes.light.primary,
            type: 'polynomial',
            pointSize: 2
          }
        },
        legend: {
          position: 'top',
          alignment: 'center'
        },
        colors: ['#ccc', this.$vuetify.theme.themes.light.primary]
      }
    };
  },
  methods: {
    EMACalc (mArray, mRange) {
      var k = 2/(mRange + 1);
      // first item is just the same as the first item in the input
      mArray[0].avg = mArray[0].amount;
      // for the rest of the items, they are computed with the previous one
      for (var i = 1; i < mArray.length; i++) {
        mArray[i].avg = mArray[i].amount * k + mArray[i - 1].amount * (1 - k)
      }
      return mArray;
    },
    unformatDate (date) {
      if (!date) {
        return null
      }
      const [day, month, year] = date.split('-')
      return `${year}-${month}-${day}`
    },
    getData () {
      this.$http
      .get('service/stats/getTotals')
      .then(response => {
        // console.log('archived invoices response', response.data);
        this.getDataByMonth();
        this.getUnpayed();
        this.getDataByWeekDayPerHour();
        this.data = response.data[0];
      })
      .catch(function (error) {
        console.log('catch:', error);
      });
    },
    getDataByMonth () {
      var app = this;
      this.$http
      .post('service/stats/byMonth', { date: '2018' })
      .then(response => {
        app.bymonth = [
          {
            name: '€',
            isStacked: true,
            data: response.data[0].map((stat) => {
              return [stat.month + '-' + stat.year, stat.amount, stat.bookings]
            })
          },
          {
            name: '€ now',
            data: response.data[1].map((stat) => {
              return [stat.month, stat.amount]
            })
          }
        ];
        app.bymonthStack = [
          {
            name: '€ asbl',
            data: response.data[0].map((stat) => {
              return [stat.month + '-' + stat.year, stat.profit]
            })
          },
          {
            name: '€ driver',
            isStacked: true,
            data: response.data[0].map((stat) => {
              return [stat.month + '-' + stat.year, (stat.amount - stat.profit)]
            })
          }
        ];
        app.bymonthBookings = [
          {
            name: 'bookings',
            data: response.data[0].map((stat) => {
              return [stat.month + '-' + stat.year, stat.bookings]
            })
          }
        ]
        app.getDataByDay();
        app.getDataByDay6m();
      })
      .catch(function (error) {
        console.log('catch:', error);
      });
    },
    getDataByDay () {
      var app = this;
      this.$http
      .post('service/stats/byDay', { date: '2018' })
      .then(response => {
        response.data = sma(response.data, 14);

        console.log('byDay response', response.data);

        app.byday = [
          {
            name: '€ asbl',
            data: response.data.map((stat) => {
              return [app.unformatDate(stat.day), (stat.profit)]
            })
          },
          {
            name: '€ driver',
            isStacked: true,
            data: response.data.map((stat) => {
              return [app.unformatDate(stat.day), (stat.amount - stat.profit)]
            })
          }
        ];
        app.bydayTotal = [
          {
            name: '€ byday',
            isStacked: true,
            data: response.data.map((stat) => {
              return [app.unformatDate(stat.day), (stat.amount)]
            })
          }
        ];

        app.chartData = response.data.map((stat) => {
          return [app.unformatDate(stat.day), (stat.profit), (stat.avg || stat.profit)]
        });
        app.chartData.unshift(['Day', '€ day', 'avg']);
        // console.log('byDay response', app.byday);
      })
      .catch(function (error) {
        console.log('catch:', error);
      });
    },
    getDataByDay6m () {
      var app = this;
      this.$http
      .post('service/stats/byDay6m', { date: '2018' })
      .then(response => {
        ///: console.log('byDay response', response.data);
        var data = {}
        response.data.forEach((stat) => {
          data[app.unformatDate(stat.day)] = stat.bookings;
        });

        app.byday6m = [{name: 'bookings by day', data: data}];

        // console.log('byDay response', app.byday);
      })
      .catch(function (error) {
        console.log('catch:', error);
      });
    },
    getDataByWeekDayPerHour () {
      var app = this;
      this.$http
      .post('service/stats/byWeekDayPerHour', { date: '2018' })
      .then(response => {

        var data = {}
        response.data[0].forEach((stat) => {
          data[stat.day_name + ' ' + stat.hour + 'h'] = stat.amount;
        });

        app.bookingsByHour = [{name: 'bookings by hour', data: data}];

        // console.log('bookings by hour', app.bookingsByHour);
      })
      .catch(function (error) {
        console.log('catch:', error);
      });
    },
    getUnpayed () {
      this.$http
      .get('service/stats/unpayed')
      .then(response => {
        this.getDataByMonth();
        this.unpayed = {
          total: response.data[0][0],
          late: response.data[1][0],
          list: response.data[2].map((u) => {
            return [u.clientId + '. ' + u.lastname, u.amount, u.lastname + ' ' + u.firstname];
          }).slice(-10).reverse()
        }

        // console.log('unpayed invoices response', response.data[2]);
      })
      .catch(function (error) {
        console.log('catch:', error);
      });
    }
  },
  created () {
    this.getData();
  }
};
</script>
<style lang="scss">

</style>
